<template>
    <div class="err">
        <div>
            <img src="../assets/imgs/err.png" alt="">
            <p>{{msg}}</p>
        </div>
    </div>
</template>
<script>

export default {
    data() {
        return {
            msg: ""
        }
    },
    created() {
        var that = this;
        console.log(111)
        that.msg = localStorage.getItem("errMsg");
    },
    mounted() {
        var that = this;
        

        // 监听浏览器后退
        if (window.history && window.history.pushState) {
            // 向历史记录中插入了当前页
            history.pushState(null, null, document.URL);
            window.addEventListener('popstate', that.goBack, false);
        }
    },
    destroyed () {
        var that = this;
        // 删除浏览器后退
        window.removeEventListener('popstate', that.goBack, false);
    },
    methods: {
        goBack() {
            history.pushState(null, null, document.URL);
        }
    }
}
</script>
<style lang="scss" scoped>
    @function rem($args) {
        $uiWidth: 75px;
        @return $args/$uiWidth*1rem;
    }
    .err{
        position: absolute;
        left: 0;
        width: 100%;
        bottom: 0;
        top: 0;
        background: #fff;
        z-index: 2;
        >div{
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            >img{
                display: block;
                width: rem(128px);
                height: rem(128px);
                margin-bottom: 10px;
            }
            >p{
                text-align: center;
                line-height: rem(36px);
                font-size: rem(24px);
            }
        }
    }
</style>
